import { Anchor } from '@mantine/core';
import pluralize from 'pluralize';
import { Fragment } from 'react';
import type { CalendarEvent } from 'src/meetings/models';
import { getGuestDisplayData } from '../utils/event-utils';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  event: CalendarEvent;
};

export const GuestSummary = ({ event }: Props) => {
  const guestDisplay = getGuestDisplayData(event);

  if (guestDisplay.knownGuests.length === 0) {
    const unknownLabel = `${guestDisplay.unknownCount} unknown ${pluralize('guest', guestDisplay.unknownCount)}`;
    return <>{unknownLabel}</>;
  }

  const totalGuestsText = `${guestDisplay.totalGuests} ${pluralize('guest', guestDisplay.totalGuests)}`;

  return (
    <>
      {totalGuestsText}:{' '}
      {guestDisplay.knownGuests.map((guest, index) => {
        const key =
          guest.participantType === 'CLIENT'
            ? `${guest.participantType}-${guest.clientId}-${index}`
            : `${guest.participantType}-${guest.userId}-${index}`;

        return (
          <Fragment key={key}>
            {index > 0 && ', '}
            {guest.participantType === 'CLIENT' ? (
              <Anchor
                href={`/client/${guest.clientId}/non-financial-data/personal-details`}
                target="_blank"
                rel="noopener noreferrer"
                c="brand.8"
                td="none"
                style={{ cursor: 'pointer' }}
                fw={FONT_WEIGHTS.medium}
              >
                {guest.name}
              </Anchor>
            ) : (
              <span style={{ fontWeight: FONT_WEIGHTS.medium }}>{guest.name}</span>
            )}
          </Fragment>
        );
      })}
      {guestDisplay.unknownCount > 0 &&
        `, and ${guestDisplay.unknownCount} unknown ${pluralize('guest', guestDisplay.unknownCount)}`}
    </>
  );
};
